/**
 * Finds substances matching what a kid typed: a name ("iron", "hyd"), a symbol ("Fe", "H2O")
 * or an atomic number ("26"). Best matches come first:
 * exact symbol or number, then names starting with the text, then names containing it.
 */
export function searchSubstances(substances, query) {
  const text = query.trim().toLowerCase();
  if (!text) return [];
  const rankOf = (substance) => {
    const name = substance.name.toLowerCase();
    const symbol = substance.symbol.toLowerCase();
    const plainFormula = (substance.plainFormula ?? '').toLowerCase();
    if (symbol === text || plainFormula === text || String(substance.atomicNumber ?? '') === text) return 0;
    if (name.startsWith(text)) return 1;
    if (name.includes(text)) return 2;
    return null;
  };
  return substances
    .map((substance, index) => ({ substance, index, rank: rankOf(substance) }))
    .filter(({ rank }) => rank !== null)
    .sort((first, second) => first.rank - second.rank || first.index - second.index)
    .map(({ substance }) => substance);
}
